import React from "react";
import ReactDOM from "react-dom";
import App from "./app/app";
import store from "./app/store";
import "./assets/css/bootstrap.min.css";
import "./assets/css/font-awesome.min.css";
import "./styles.scss";
import { Provider } from "react-redux";
import * as serviceWorker from "./serviceWorker";

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
